import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const PictureCardBodyKicker = props => {
  const { className, children, ...other } = props;
  return (
    <p className={clsx("em-c-picture-card__kicker", className)} {...other}>
      {children}
    </p>
  );
};

PictureCardBodyKicker.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

PictureCardBodyKicker.defaultProps = {
  className: "",
  children: null
};

export default PictureCardBodyKicker;
